import * as ActionTypes from "../Types/ActionTypes";

const initialState = {
  projectStageReports: [],
  loading: false,
  error: null,
};

export const StageUpdation = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_PROJECT_STAGE_REPORTS:
      return {
        ...state,
        projectStageReports: action.payload,
        loading: false,
        error: null,
      };

    case ActionTypes.PROJECT_STAGE_REPORTS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ActionTypes.PROJECT_STAGE_REPORTS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};